import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestBuyDisplayed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 14,
	fill: "none",
	viewBox: "0 0 22 14",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M11 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM9 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "m21.2 7-.6.8a20.6 20.6 0 0 1-2.6 3 10.9 10.9 0 0 1-7 3.2c-2.9 0-5.4-1.7-7-3.3a20.6 20.6 0 0 1-2.6-2.9L.8 7l.4-.6.7-1a20.6 20.6 0 0 1 2-2.1C5.7 1.7 8.2 0 11 0c2.9 0 5.4 1.7 7 3.3a20.6 20.6 0 0 1 2.6 2.9l.6.8Zm-18 0a18.8 18.8 0 0 1 2.1-2.3C7 3.3 9 2 11 2s4.1 1.3 5.7 2.7c1 .9 1.6 1.8 2 2.3a18.8 18.8 0 0 1-2 2.3C15 10.7 13 12 11 12s-4.1-1.3-5.7-2.7a18.8 18.8 0 0 1-2-2.3Z",
		clipRule: "evenodd"
	})]
});
export default SvgTestBuyDisplayed;
